import {HttpContext, HttpParams} from '@angular/common/http';
import {FacetExtractors} from '@aviary/store/common/common.types';
import {isObject} from '@aviary/store/common/typing.helpers';

export type RequestParamValue = string | number | boolean;

export type RequestParams = HttpParams | Record<string, RequestParamValue | ReadonlyArray<RequestParamValue>>;

export interface DeleteOptions {
  params?: RequestParams;
  context?: HttpContext;
}

export interface GetOptions {
  params?: RequestParams;
  context?: HttpContext;
}

export interface PatchOptions {
  params?: RequestParams;
  context?: HttpContext;
}

export interface PostOptions {
  params?: RequestParams;
  context?: HttpContext;
}

export interface PutOptions {
  params?: RequestParams;
  context?: HttpContext;
}

export interface ListDataOptions<OptionsType> {
  httpOptions?: OptionsType;
  facetExtractors?: FacetExtractors;
  includePaginationInfo?: boolean;
}


export type ListDataOptionsOrSimply<OptionsType> = OptionsType | ListDataOptions<OptionsType>;

export function isListDataOptions<OptionsType>(thing?: unknown): thing is ListDataOptions<OptionsType> {
  return isObject(thing) && ('httpOptions' in thing || 'facetExtractors' in thing || 'includePaginationInfo' in thing);
}

export class ApiContractError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ApiContractError';
  }
}
